/**
 * Namespacing
 */
$.namespace = require('lib/util/helpers').namespace;

var SCS = $.namespace("SCS");
SCS.ajaxTimeout = 300000; // 5min

$.ajaxSetup({
	error : function(jqXHR, textStatus, errorThrown) {
		if (SCS.portal.errorHandling) {
			SCS.portal.errorHandling(jqXHR.responseText);
		}
	},
	timeout : SCS.ajaxTimeout
});



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/vendor/jquery/jquery-extensions.js
// module id = 64
// module chunks = 0